export const ALERT_BANNER_NO_HISTORIZATION = "no_historic"

export const BANNER_INFO_STATUS = "info"
export const BANNER_WARNING_STATUS = "warning"
export const BANNER_SUCCESS_STATUS = "success"
export const BANNER_CRITICAL_STATUS = "critical"
